var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M444.862 109.779 338.221 3.138A10.63 10.63 0 0 0 330.667 0h-224C83.146 0 64 19.135 64 42.667v426.667C64 492.865 83.146 512 106.667 512h298.667c23.52 0 42.666-19.135 42.666-42.667v-352a10.63 10.63 0 0 0-3.138-7.554zM160 149.333c-17.646 0-32-14.354-32-32 0-13.888 8.944-25.617 21.333-30.035v-1.965c0-5.896 4.771-10.667 10.667-10.667s10.667 4.771 10.667 10.667h10.667C187.229 85.333 192 90.104 192 96s-4.771 10.667-10.667 10.667H160c-5.875 0-10.667 4.781-10.667 10.667 0 5.885 4.792 10.667 10.667 10.667 17.646 0 32 14.354 32 32 0 13.888-8.944 25.617-21.333 30.035V192c0 5.896-4.771 10.667-10.667 10.667s-10.667-4.771-10.667-10.667h-10.667a10.66 10.66 0 0 1-10.667-10.667 10.66 10.66 0 0 1 10.667-10.667H160c5.875 0 10.667-4.781 10.667-10.667s-4.792-10.666-10.667-10.666zM266.667 448h-128A10.66 10.66 0 0 1 128 437.333a10.66 10.66 0 0 1 10.667-10.667h128a10.66 10.66 0 0 1 10.667 10.667A10.662 10.662 0 0 1 266.667 448zm106.666-64H138.667A10.66 10.66 0 0 1 128 373.333a10.66 10.66 0 0 1 10.667-10.667h234.667a10.66 10.66 0 0 1 10.667 10.667A10.662 10.662 0 0 1 373.333 384zm0-64H138.667A10.66 10.66 0 0 1 128 309.333a10.66 10.66 0 0 1 10.667-10.667h234.667a10.66 10.66 0 0 1 10.667 10.667A10.662 10.662 0 0 1 373.333 320zm0-64H138.667A10.66 10.66 0 0 1 128 245.333a10.66 10.66 0 0 1 10.667-10.667h234.667a10.66 10.66 0 0 1 10.667 10.667A10.662 10.662 0 0 1 373.333 256zm0-64h-128a10.66 10.66 0 0 1-10.667-10.667 10.66 10.66 0 0 1 10.667-10.667h128A10.66 10.66 0 0 1 384 181.333 10.66 10.66 0 0 1 373.333 192zm-10.666-85.333c-11.771 0-21.333-9.573-21.333-21.333V36.417l70.25 70.25h-48.917z",
    fill: "#8BA4BF",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.40f84290ac10e1619bf097ba35caa7d4.svg";
export { ForwardRef as ReactComponent };